export const JOY_HELP_URL = 'https://help.withjoy.com/';
export const JOY_ABOUT_URL = 'https://withjoy.com/about/';
